module.exports = __webpack_public_path__ + "img/img005.cfc449b0.png";